import type { Locale } from './locale'

export const localizedRoutes = ['/', '/about', '/configurator', '/company', '/announcements', '/status', '/terms', '/privacy', '/blog', '/newsroom']
export const stripLocale = (path: string) => path.replace(/^\/jp(?=\/|$)/, '') || '/'
export const localeFromPath = (path: string): Locale => /^\/jp(?:\/|$)/.test(path) ? 'ja' : 'en'
export function localizedPath(target: string, locale: Locale): string {
  if (!target.startsWith('/') || target.startsWith('//')) return target
  const boundary = target.search(/[?#]/)
  const pathname = boundary < 0 ? target : target.slice(0, boundary)
  const suffix = boundary < 0 ? '' : target.slice(boundary)
  const base = stripLocale(pathname).replace(/\/+$/, '') || '/'
  if (!localizedRoutes.includes(base)) return target
  return (locale === 'ja' ? '/jp' + (base === '/' ? '' : base) : base) + suffix
}
